//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/FacetCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/FacetCollector.js";
let d=[[[1,"FacetRegion",0,"FacetCollector",0],[1,"FacetTransitionRegions",0,"FacetCollector",0],[0,"IsEditCopy",1,0],[0,"IsRegenerateOffsetMesh",1,0],[0,"IsReverseDirection",1,0],[0,"IsSmoothEdge",1,0],[1,"OffsetDistance",0,"Expression",0],[1,"RegionDistance",0,"Expression",0],[0,"ShapeMethod",1,0],[0,"TransitionMethod",1,0]],[],[]];
SPLM.Facet.LocalOffsetBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.LocalOffsetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.LocalOffsetBuilder.TransitionMethodType = Object.freeze({
    "None" : "None", "ByConstantOffset" : "ByConstantOffset", "ByRegionSelection" : "ByRegionSelection"});

SPLM.Facet.LocalOffsetBuilder.ShapeMethodType = Object.freeze({
    "Sharp" : "Sharp", "Smooth" : "Smooth"});

export default SPLM;